import { createFileRoute } from '@tanstack/react-router'

import HomePage from '@/layouts/themes/phong-nha/pages/home'

export const Route = createFileRoute('/phong-nha/')({
  component: HomePage,
})
